module.exports = __webpack_public_path__ + "img/qx55-25.d5c00381.png";